import React, { memo } from 'react';
import styled from 'styled-components';
import { Typo, ReviewStar } from 'tmt-ui-kit';

// import ReviewStar from './ReviewStar';

const Container = styled.div`
  margin-bottom: ${props => (props.noCategory ? 0 : 36)}px;
  @media(max-width: 768px) {
    margin-bottom: 14px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const Title = styled(Typo.HeaderTwo)`
  margin: 0;
`;

const TitleCategory = styled(Typo.Paragraph)`
  margin: 0;
`;

const ReviewCount = styled(Typo.Paragraph)`
  display: inline;
`;

const ReviewCategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ReviewCategory = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  width: 50%;
  @media(max-width: 700px) {
    margin-bottom: 2px;
    width: 100%;
  }
`;

const CategoryStarContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const ReviewScore = props => {
  const { trip, rating, categoryScore, withoutReview, noCount } = props;
  const score = typeof rating === 'number' ? rating : rating.average_rating;
  const reviewCount = trip.review_count + (withoutReview || 0);
  let noCategory = false;
  if (!categoryScore) noCategory = true;
  else if (!categoryScore.friendly_score && !categoryScore.area_score && !categoryScore.language_score) noCategory = true;

  return (
    <Container noCategory={noCategory}>
      <TitleContainer>
        <ReviewCategory>
          <Title>Reviews {!noCount && <ReviewCount>({ reviewCount })</ReviewCount>}</Title>
          <CategoryStarContainer>
            <ReviewStar score={score} starSize={19} textSize={16} textWeight={500} />
          </CategoryStarContainer>
        </ReviewCategory>
      </TitleContainer>
      {categoryScore && (
        <ReviewCategoryContainer>
          {categoryScore.friendly_score > 0 && (
            <ReviewCategory>
              <TitleCategory>Friendliness</TitleCategory>
              <CategoryStarContainer>
                <ReviewStar score={categoryScore.friendly_score} textSize={15} />
              </CategoryStarContainer>
            </ReviewCategory>
          )}
          {categoryScore.area_score > 0 && (
            <ReviewCategory>
              <TitleCategory>Area Expert</TitleCategory>
              <CategoryStarContainer>
                <ReviewStar score={categoryScore.area_score} textSize={15} />
              </CategoryStarContainer>
            </ReviewCategory>
          )}
          {categoryScore.language_score > 0 && (
            <ReviewCategory>
              <TitleCategory>Language Proficiency</TitleCategory>
              <CategoryStarContainer>
                <ReviewStar score={categoryScore.language_score} textSize={15} />
              </CategoryStarContainer>
            </ReviewCategory>
          )}
        </ReviewCategoryContainer>
      )}
    </Container>
  );
};

export default memo(
  ReviewScore,
  () => true
);
